import React  from 'react';
// import NextButton from '../nextButton';
import finik from './images/res-finik2_l.png';
import planeta from './images/planeta.png';
import styled, { keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';

import './style.css';

const FinikBl2 = styled.img`
	animation: 3s ${keyframes`${zoomIn}`} ;
  position: absolute;
  left: 5%;
  top: auto;
  right: auto;
  bottom: 5%;
  z-index: 1;
  width: 280px;
	@media screen and (max-width: 991px) {
    /* left: 4%; */
    top: auto;
    right: auto;
    bottom: 2%;
    width: 230px;
  }
	@media screen and (max-width: 767px) {
    width: 200px;
  }
	@media screen and (max-width: 479px) {
    /* left: 0; */
    top: auto;
    right: auto;
    bottom: 0%;
    width: 160px;
  }
`;

const PlanetaW = styled.img`
	position: absolute;
  left: 2%;
  top: 5%;
  right: auto;
  bottom: auto;
  opacity: 0.1;

	@media screen and (max-width: 767px) {
    display: none;
  }
	
`;


const Words = ({ onNextLevel, messNext, answer, setAnswer, words }) => {
	
// console.log(words);

	const elements = words.map((item,id) => {

	const name = item;
	let classNames = 'words-line-text ';
		if( id % 2) classNames += " _2";

	return (
		<button key={id+name} 
			className={classNames}
			onClick={(e)=> {
			setAnswer(e.target.textContent);
			onNextLevel(e.target.textContent);
		}}
		>{name}</button>
	);
});


  return ( 
		<div className="section">
			<div className="container">
				<div className="words-head">Найди ЛИшнее слово</div>
				<div className="words-wrapper">
					<div className="words-head mobile">Найди ЛИшнее слово</div>
					{/* <div className="words-text-block blue margin">Вот несколько слов из мира финансов</div> */}

					<div className="quest-box">
						<div className="row">
							<div className="quest-box_input">
							<div className="words-text-block">Вот несколько слов из мира финансов. Выбери <span className="text-span">лишнее </span>и нажми кнопку.</div>
								{/* <NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="Дальше" /> */}
								</div>
						</div>
						<div className="row">
						<div className="quest-box_words">
							{elements}
						</div>
						</div>

					</div>

						<FinikBl2 src={finik} loading="lazy" alt="" className="finik-bl2"/>
						<PlanetaW src={planeta} loading="lazy" alt="" className="planeta"/>
						</div>
			</div>
		</div>

      );
}

export default Words;
